import React from 'react'
import PropTypes from 'prop-types'
import { Link } from "react-router-dom";

export default function Navbar(props) {
  return (
    <nav className={`navbar bg-${props.Mode}`} data-bs-theme={`${props.Mode}`}>
    <div className="container-fluid">
      <Link className="navbar-brand" to="/"><b><i>{props.title}</i></b></Link>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
          <li className="nav-item">
            <Link to="/" className="nav-link active" aria-current="page">Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link" >{props.aboutText}</Link>
          </li>
        </ul>

        <div className={`form-check form-switch text-${props.Mode==='light'?'dark':'light'} `} >
          <input className="form-check-input" onClick={props.toggleMode} type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
          <label className="form-check-label" HTMLfor="flexSwitchCheckDefault">Enable Dark Mode</label>
        </div>

        {/* <form className="d-flex" role="search">
          <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
          <button className="btn btn-success" type="submit">Search</button>
        </form> */}
        </div>
      </div>
      </nav>
  )
}

Navbar.propTypes = { 
    title : PropTypes.string.isRequired,
    aboutText : PropTypes.string.isRequired
}

Navbar.defaultProps = {
    title: 'set Title here',
    aboutText : 'About'
  };
